import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import StressFreeWeddingPlanning from "./sections/StressFreeWeddingPlanning";
import ServiceOptions from "./sections/ServiceOptions";
import WhyCouplesChooseABStudios from "./sections/WhyCouplesChooseABStudios";
import Deliverables from "./sections/Deliverables";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <StressFreeWeddingPlanning />
      <ServiceOptions />
      <WhyCouplesChooseABStudios />
      <Deliverables />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}